import { d as defineComponent, c as createElementBlock, w as withDirectives, v as vShow, u as unref, a as createBaseVNode, b as createBlock, e as withCtx, n as normalizeClass, o as openBlock, r as renderSlot, s as safelyRegisterElement } from "../customElements.es.js";
import { u as useElementSetup, _ as _sfc_main$1, R as RegisterRoute } from "../customElements.es2.js";
import "../customElements.es3.js";
const _hoisted_1 = { class: "container" };
const _sfc_main = defineComponent({
  __name: "RegisterApp.ce",
  props: {
    appId: {},
    beforeAuth: { type: Function },
    onSuccess: { type: Function },
    onEvent: { type: Function },
    tokenStore: {},
    lang: {},
    defaultCountryCode: {},
    theme: {}
  },
  setup(__props) {
    const props = __props;
    const { languageLoading, containerRef, currentTheme } = useElementSetup(props);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        id: "passage-auth-container",
        class: normalizeClass(["passage-register passage-auth", unref(currentTheme)]),
        ref_key: "containerRef",
        ref: containerRef
      }, [
        withDirectives(createBaseVNode("div", _hoisted_1, [
          (openBlock(), createBlock(_sfc_main$1, {
            key: _ctx.appId,
            homeRoute: unref(RegisterRoute),
            authContainerRef: unref(containerRef),
            theme: unref(currentTheme)
          }, {
            otpInput: withCtx(() => [
              renderSlot(_ctx.$slots, "otpInput")
            ]),
            _: 3
          }, 8, ["homeRoute", "authContainerRef", "theme"]))
        ], 512), [
          [vShow, !unref(languageLoading)]
        ])
      ], 2);
    };
  }
});
function registerPassageRegisterElement() {
  safelyRegisterElement(_sfc_main, "register");
}
registerPassageRegisterElement();
export { registerPassageRegisterElement };
//# 
